import CoreDrawer from '@/components/CoreDrawer';
import { DetailProps } from '@/domain/entities/detail';
import GetListPermission from '@/modules/permission/viewmodels/getAll';

import { Spin, Typography } from 'antd';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useViewModel from '../../viewmodels/detail';
import { RolesForm } from './RolesForm';

type RoleDetailProps = Omit<DetailProps, 'setRefresh'>;

export const Detail: React.FC<RoleDetailProps> = (props: RoleDetailProps): JSX.Element => {
  const { open, handleClose, setOpen } = props;
  const { loadingDetailRoles, errorDetailRoles, detailRoles, actionGetDetail } = useViewModel();
  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');
  const { listPermission, actionGetListPermission, loadingListPermission, errorListPermission } =
    GetListPermission();

  useEffect(() => {
    if (
      (showId !== null && getAction === 'Detail') ||
      (showId !== null && getAction === 'Duplicate') ||
      (showId === null && getAction === 'Create')
    ) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [showId, getAction, setOpen]);

  useEffect(() => {
    if (open && showId) {
      actionGetDetail();
    }
  }, [open, showId, actionGetDetail]);

  useEffect(() => {
    if (open) {
      actionGetListPermission();
    }
  }, [open, actionGetListPermission]);

  const rolesFormShown =
    !errorDetailRoles &&
    !loadingDetailRoles &&
    detailRoles.data.id !== '' &&
    !errorListPermission &&
    !loadingListPermission &&
    listPermission &&
    Array.isArray(listPermission.Permission_getAll) &&
    listPermission.Permission_getAll.length > 0;

  const rolesFormShownWithoutId =
    !errorListPermission &&
    !loadingListPermission &&
    Array.isArray(listPermission.Permission_getAll) &&
    listPermission.Permission_getAll.length > 0;

  const renderContent = () => {
    if (showId) {
      return (
        <>
          <div>{(loadingDetailRoles || loadingListPermission) && <Spin />}</div>
          {(errorDetailRoles || errorListPermission) && <div>Error</div>}
          {rolesFormShown && (
            <RolesForm
              detailRole={detailRoles.data}
              openForm={open}
              showId={showId}
              listPermission={listPermission.Permission_getAll}
            />
          )}
        </>
      );
    }
    return (
      <>
        <div>{loadingListPermission && <Spin />}</div>
        {errorListPermission && <div>Error</div>}
        {rolesFormShownWithoutId && (
          <RolesForm
            detailRole={detailRoles.data}
            openForm={open}
            showId={showId}
            listPermission={listPermission.Permission_getAll}
          />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      title={
        <div>
          <Typography.Title level={5}>Roles</Typography.Title>
        </div>
      }
      content={renderContent()}
    />
  );
};
